import { Fragment } from 'react'

import functions from 'helpers/functions'
import constants from 'constants/index'

const definitionByLabel = (label) => {
  label = functions.capitalizeText(label)
  return constants.cardFlag.CARD_FLAG_DEFINITION_BY_LABEL[label] || Fragment
}

export default definitionByLabel
